export default __webpack_public_path__ + "static/media/cm_2.d5321e25.png";